import { ENavigationIcon } from "@frontend-shared/types";
import type { ComponentType } from "react";

import { Agents } from "./Agents";
import { Analytics } from "./Analytics";
import { AnonymizationLab } from "./AnonymizationLab";
import { Assistants } from "./Assistants";
import { CallAssistant } from "./CallAssistant";
import { Code } from "./Code";
import { Dashboards } from "./Dashboards";
import { DocRecognition } from "./DocRecognition";
import { Integrations } from "./Integrations";
import { Knowledge } from "./Knowledge";
import { Library } from "./Library";
import { Models } from "./Models";
import { NewChat } from "./NewChat";
import { PromptLibrary } from "./PromptLibrary";
import { Skills } from "./Skills";
import type { TIconProps } from "./types";
import { UploadsSidebarIcon } from "./UploadsSidebarIcon";

// NOTE: NSAI-6812 — the web glyph of every main-navigation entry. The sidebar
// and the global search palette both draw through this map (via
// NavigationIcon), so a destination can never wear two different icons.
export const NAVIGATION_ICONS: Readonly<
  Record<ENavigationIcon, ComponentType<TIconProps>>
> = {
  [ENavigationIcon.NEW_CHAT]: NewChat,
  [ENavigationIcon.DASHBOARDS]: Dashboards,
  [ENavigationIcon.CODE]: Code,
  [ENavigationIcon.CALL_ASSISTANT]: CallAssistant,
  [ENavigationIcon.UPLOADS]: UploadsSidebarIcon,
  [ENavigationIcon.ASSISTANTS]: Assistants,
  [ENavigationIcon.KNOWLEDGE]: Knowledge,
  [ENavigationIcon.DOC_RECOGNITION]: DocRecognition,
  [ENavigationIcon.SKILLS]: Skills,
  [ENavigationIcon.GENERATED_FILES]: Library,
  [ENavigationIcon.AGENTS]: Agents,
  [ENavigationIcon.ANONYMIZATION_LAB]: AnonymizationLab,
  [ENavigationIcon.PROMPT_LIBRARY]: PromptLibrary,
  [ENavigationIcon.MODELS]: Models,
  [ENavigationIcon.ANALYTICS]: Analytics,
  [ENavigationIcon.INTEGRATIONS]: Integrations,
};
